"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryService = void 0;
const api_1 = require("../api");
class QueryService {
    constructor(fetch) {
        this.fetch = fetch;
        this.apiVersion = api_1.apiVersion;
    }
    listSecrets(params = {}) {
        return this.query(Object.assign({ operation: "list", kinds: ["secret"], keep_ids: true, spec_versions: { secret: "v1" } }, params));
    }
    listPipelines(params = {}) {
        return this.query(Object.assign({ operation: "list", kinds: ["pipeline"], keep_ids: true, spec_versions: { pipeline: "v2" } }, params));
    }
    listConnections(params = {}) {
        return this.query(Object.assign({ operation: "list", kinds: ["connection"], keep_ids: true, spec_versions: { connection: "v2" } }, params));
    }
    listStreams(params = {}) {
        return this.query(Object.assign({ operation: "list", kinds: ["stream"], keep_ids: true, include_immutables: true, spec_versions: { stream: "v1" } }, params));
    }
    query(params) {
        var _a, _b, _c, _d, _e;
        var _f, _g, _h, _j;
        return __awaiter(this, void 0, void 0, function* () {
            /**
             * Ensure we always have a stable default
             * See # incident-2024-10-24-job-status-errors
             */
            if (params.spec_versions !== null) {
                (_a = params.spec_versions) !== null && _a !== void 0 ? _a : (params.spec_versions = {});
                (_b = (_f = params.spec_versions).pipeline) !== null && _b !== void 0 ? _b : (_f.pipeline = "v2");
                (_c = (_g = params.spec_versions).connection) !== null && _c !== void 0 ? _c : (_g.connection = "v2");
                (_d = (_h = params.spec_versions).stream) !== null && _d !== void 0 ? _d : (_h.stream = "v1");
                (_e = (_j = params.spec_versions).secret) !== null && _e !== void 0 ? _e : (_j.secret = "v1");
            }
            const data = yield this.fetch(`/${this.apiVersion}/query`, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-yaml",
                },
                body: JSON.stringify(params),
            });
            return data.items;
        });
    }
    apply(params, opts = { dryRun: false }) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.fetch(`/${this.apiVersion}/apply?dry_run=${opts.dryRun}`, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-yaml",
                },
                body: JSON.stringify(params),
            });
            return data.items;
        });
    }
    queryAsYaml(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.fetch(`/${this.apiVersion}/query`, {
                method: "POST",
                headers: {
                    Accept: "application/x-yaml",
                    "Content-Type": "application/x-yaml",
                },
                body: JSON.stringify(params),
            });
        });
    }
    applyAsYaml(yaml, opts = { dryRun: false }) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield this.fetch(`/${this.apiVersion}/apply?dry_run=${opts.dryRun}`, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/x-yaml",
                },
                body: yaml,
            });
            return data.items;
        });
    }
}
exports.QueryService = QueryService;
